import { render } from "./AIShareGuide.vue?vue&type=template&id=0a782622&scoped=true&ts=true"
import script from "./AIShareGuide.vue?vue&type=script&lang=ts"
export * from "./AIShareGuide.vue?vue&type=script&lang=ts"

import "./AIShareGuide.vue?vue&type=style&index=0&id=0a782622&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a782622"]])

export default __exports__